module.exports = __webpack_public_path__ + "static/fesw-logo-black-e1890b3a556014e68e9ca75c93912606.png";